import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Presskit`}</h1>
    <h2>{`About Us`}</h2>
    <p>{`Viral Spiral is an adaptive digital card game about sharing news on the Internet. The game reflects the ways and reasons misinformation is shared, letting players experience first hand the temptation to share fake news for their own gain and face the consequences of the harm it causes around them.`}</p>
    <p>{`Viral Spiral has been a team work initiated by Game Designer Adhiraj Singh and Game Developer Tattle Civic Technologies. Its is supported by the `}<a parentName="p" {...{
        "href": "https://www.mercatus.org/features/mercatus-program-pluralism-civil-exchange-announces-first-cohort-grant-recipients"
      }}>{`Pluralism and Civic Exchange grant`}</a>{` from the Mercatus Center.`}</p>
    <h2>{`Our team :`}</h2>
    <ul>
      <li parentName="ul">{`Adhiraj Singh, Game Designer`}</li>
      <li parentName="ul">{`Aman Jotwani, Senior Game Writer`}</li>
      <li parentName="ul">{`Denny George, Product Engineer`}</li>
      <li parentName="ul">{`Farah Ahmad, Visual Designer and Illustrator`}</li>
      <li parentName="ul">{`Krys Martis, Game Writer`}</li>
      <li parentName="ul">{`Rishav Thaker, Fullstack Developer`}</li>
      <li parentName="ul">{`Tarunima Prabhakar, Researcher`}</li>
      <li parentName="ul">{`Mitali, Illustrator`}</li>
    </ul>
    <h2>{`Video Walkthrough`}</h2>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/FbUeYm8ifWs" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
    <h2>{`Images`}</h2>
    <div {...{
      "style": {
        "width": "16em"
      }
    }}>{`
  `}<span parentName="div" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3a454023050f8cae7225ae43f4ee10c8/70ad2/viral-spiral-pk-1.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.00000000000001%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAADDUlEQVQoz23Rb1DTBRjA8R9dvvYVveq68+jOrLgjLy0S7ND4N+tNEFwkLGU3KIMcSNhgJ1occ5ttMET+TjDGBptLNhzocn9p45jNjRR2MUovs8IdJeaLXn37dXbXm1583jzPPd83j2BfGub9jgpyJRKOtB+m7rgOjXEW/1wS243fsC6tY0085riZZib5B+PxO2hD85hjKeaWbQz499F2uQiZPRvhkz4Vee37yG16hXe0XfQFUkz9E7n5AEsizVerD3GlHjGdfIhndRNPahPHLXG3dIeR4DUmr3txL19A79ZQo65CyHs3h/bPc7hyqZJajZT8T3X0OGNEIxEWf0gTdIaZnw3x3coK0dsbRNfuk/hxnW9vp1m5u87Xt5axJW6IN/3IlHKErP17CXY3sDE9xcK8GLGZSZwfI+kcY8YzQepCDzGTiaTXwmZqhp+/v8x01EGLc5S5pRCu+Dfo/FOYvAYa9McRnpEU0DlUQV2PGnPvML4hI79YTVwctzI4OsSqz006EuSuf47NsItY0MnErJ26KROnPE7O+GYxBK7SOTmGXKNC2F29mxO2p9ijKSOq7WPtjIFHys9wjQ5zf+E6a24PP3l8bITCrAcjPAhH+XNhkU7XOTFkoT98kd6wnW5HDx1GGUJuxU6qTu7EeO1V7hm6oFXDX4pO4g4VsXAvca+ReOAssUAfEW8vEd85At4v6HDtot9fzaWrjVjcH6C3tiI9VY6QL3uNrMYCnteUsjgyzD3jl/yqOY96oIksbQ7Z6pd4Tv2iaDsvaJ4lW7uNbN3T5Om3oR07xOSgAvvZjzhtPka5skx8SmU+mbXFCLJitrdKebntMLvaask8WoFQX4JwVCIqRVCImkr+VcxWxZuU65W8PXACxWQLiol2pIaDCJkH9qBskDOoP02Jqgah4nWEqgKEg/t5Ql5ERn0hGXVF/6kvQjhSyBYxeKBbSeN4G632FprNKuT91Qhby3YQGtHy+xU/H3YpEN7by5OHSsmQiofVhf/j8XyLXMIbumZqRo7xsbWBJkszb52s5G8AVUGGMXujXAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Viral Spiral",
            "title": "Viral Spiral",
            "src": "/static/3a454023050f8cae7225ae43f4ee10c8/c1b63/viral-spiral-pk-1.png",
            "srcSet": ["/static/3a454023050f8cae7225ae43f4ee10c8/5a46d/viral-spiral-pk-1.png 300w", "/static/3a454023050f8cae7225ae43f4ee10c8/0a47e/viral-spiral-pk-1.png 600w", "/static/3a454023050f8cae7225ae43f4ee10c8/c1b63/viral-spiral-pk-1.png 1200w", "/static/3a454023050f8cae7225ae43f4ee10c8/70ad2/viral-spiral-pk-1.png 1665w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      